import { sexpressConfig } from '../api';
import GeneratedClient from './sexpressClass';

const sexpressClient = new GeneratedClient(sexpressConfig);

export default sexpressClient;
